<template>
  <div class="p-3 mb-2 mt-4 mx-lg-5 mx-md-2 mx-sm-2 rounded-8">
    <div class="d-flex justify-content-between mb-3">
      <h4><strong style="color:#1A0054">Insignias</strong></h4>
    </div>
    
    <div class="table-responsive rounded-8">
      <table class="table table-responsive table-borderer text-table-normal">
        <thead class="bg-table-normal-header text-white">
          <tr>
            <th class="p-3">No.</th>
            <th class="p-3">Ruta completada</th>
            <th class="p-3">Fecha</th>
            <th class="p-3">Descarga</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="4" class="text-center">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
            </td>
          </tr>
          
          <tr v-else-if="badges.length === 0">
            <td colspan="4" class="text-center">
              <p class="mb-0">El usuario no tiene insignias obtenidas.</p>
            </td>
          </tr>
          
          <tr v-else v-for="badge in badges" :key="badge.id">
            <td>{{ badge.id }}</td>
            <td>{{ badge.rutaNombre || '-' }}</td>
            <td>{{ formatDate(badge.fecha) }}</td>
            <td>
              <a 
                v-if="badge.url_insignia"
                :href="badge.url_insignia" 
                target="_blank" 
                rel="noopener noreferrer"
                class="btn bg-utel-v2-secondary text-primary"
                title="Descargar insignia"
              >
                <i class="fa fa-download" aria-hidden="true"></i>
              </a>
              <span v-else class="text-muted">No disponible</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentBadgesSection',
  
  props: {
    badges: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },

  methods: {
    formatDate(date) {
      if (!date) return '-'
      try {
        return new Date(date).toLocaleDateString('es-ES')
      } catch {
        return date
      }
    }
  }
}
</script>

<style scoped>
.text-table-normal {
  font-size: 12px;
  color: #1A0054;
}

.bg-table-normal-header {
  background-color: #5A1FE0;
}
</style>